import path from 'path';

export const photoUrl = (p) => {
  if (!p) { return p; }
  if (p.startsWith("http") || p.startsWith("/api/") || p.startsWith("data:") || p.startsWith("/workspace")) {
    return p;
  }
  return path.join("/", "api/v2", p);
};

export const fileUrl = photoUrl;
export const docUrl = photoUrl;

export default photoUrl;
